const PersonalDataProcessing = () => {
  return (
    <>
      <ol>
        <li>
          <p>Úvodní informace</p>
          <ol type="a">
            <li>
              <p>
                Obchodní společnost Stosuj s.r.o., IČO: 143 99 831, se sídlem: Kaprova 42/14, Staré Město, 110 00 Praha,
                zapsaná v obchodním rejstříku vedeném u Městského soudu v Praze, oddíl C, vložka 364569 (dále jen
                „Společnost“ nebo „Správce“), tímto poskytuje informace o způsobu a rozsahu zpracování osobních údajů
                klientů a návštěvníků webu stosuj.cz (dále jen „Klient“ nebo „subjekt údajů“) a o jejich právech
                souvisejících se zpracováním osobních údajů (dále jen „Zásady“).
              </p>
            </li>
            <li>
              <p>
                Tyto Zásady jsou zpracovány v souladu s Nařízením Evropského parlamentu a Rady (EU) 2016/679 (GDPR) a
                souvisejícími právními předpisy České republiky, zejména zákonem č. 110/2019 Sb., o zpracování osobních
                údajů.
              </p>
            </li>
            <li>
              <p>
                Tyto Zásady se vztahují zejména na zpracování osobních údajů v souvislosti s registrací a používáním
                webové aplikace stosuj.cz (dále jen „Aplikace“), poskytováním souvisejících služeb, komunikací s
                Klientem, plněním zákonných povinností, zabezpečením Aplikace a marketingovými aktivitami.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Správce osobních údajů a kontaktní údaje</p>
          <ol type="a">
            <li>
              <p>
                Správcem osobních údajů je Společnost uvedená v čl. 1 těchto Zásad.
              </p>
            </li>
            <li>
              <p>
                Kontaktní e-mail pro záležitosti týkající se ochrany osobních údajů: info@stosuj.cz
              </p>
            </li>
            <li>
              <p>
                Společnost zpracovává osobní údaje prostřednictvím oprávněných osob a smluvních zpracovatelů v elektronických informačních systémech provozovaných Společností nebo jejími zpracovateli, a to při uplatnění přiměřených technických a organizačních bezpečnostních opatření.
              </p>
            </li>
            <li>
              <p>
                Pokud Společnost jmenovala pověřence pro ochranu osobních údajů (DPO), zveřejní jeho kontaktní údaje na webu Společnosti nebo v Aplikaci. Pokud pověřenec jmenován nebyl, lze veškeré žádosti a dotazy směřovat na výše uvedený kontaktní e-mail.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Jaké údaje zpracováváme a z jakých zdrojů je získáváme</p>
          <ol type="a">
            <li>
              <p>
                Společnost zpracovává osobní údaje, které Klient poskytne přímo (např. při registraci, využívání Aplikace, komunikaci se Společností nebo při platbě), a dále údaje vznikající při používání Aplikace a webu.
              </p>
            </li>
            <li>
              <p>
                Typicky může jít zejména o následující kategorie údajů:
              </p>
              <ol type="i">
                <li>
                  <p>
                    identifikační a kontaktní údaje (např. e-mail, případně jméno/přezdívka, pokud je Klient uvede),
                  </p>
                </li>
                <li>
                  <p>
                    údaje o uživatelském účtu v Aplikaci (nastavení, zvolený tarif, historie aktivace funkcí, změny nastavení, preference),
                  </p>
                </li>
                <li>
                  <p>
                    údaje o používání Služby a technické provozní údaje (např. logy, časové záznamy, IP adresa, typ zařízení/prohlížeče, diagnostické a bezpečnostní údaje),
                  </p>
                </li>
                <li>
                  <p>
                    údaje související s platbami a fakturací (např. informace o objednávce, uhrazené částce, měně, stavu platby, fakturační údaje; Společnost zpravidla nezpracovává údaje o platební kartě jako číslo karty/CVV),
                  </p>
                </li>
                <li>
                  <p>
                    údaje ze vzájemné komunikace a zákaznické podpory (např. e-mailová komunikace, podněty, odpovědi),
                  </p>
                </li>
                <li>
                  <p>
                    údaje o chování na webu a v Aplikaci (např. návštěvnost, interakce s obsahem, preference) v rozsahu odpovídajícím nastavení cookies/souhlasu,
                  </p>
                </li>
                <li>
                  <p>
                    technické přístupové údaje nezbytné pro propojení Aplikace s účtem Klienta na podporované platformě v rozsahu nutném pro fungování Služby. Tyto údaje Společnost zpracovává jako bezpečnostně citlivé technické údaje.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                V odůvodněných případech může Společnost získat údaje také od třetích stran, zejména od platebních partnerů (např. potvrzení o úhradě), poskytovatelů technických služeb nebo orgánů veřejné moci, pokud tak stanoví právní předpis nebo je to nezbytné pro ochranu práv Společnosti.
              </p>
            </li>
            <li>
              <p>
                Společnost nezpracovává zvláštní kategorie osobních údajů (citlivé údaje) Klientů, ledaže by takové zpracování výslovně vyžadoval zákon nebo je Klient sám dobrovolně poskytl v rámci komunikace. V takovém případě Společnost doporučuje takové údaje neposkytovat, pokud to není nezbytné.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Účely zpracování a právní základy</p>
          <ol type="a">
            <li>
              <p>
                Společnost zpracovává osobní údaje pouze v rozsahu nezbytném pro konkrétní účel a na základě odpovídajícího právního titulu dle GDPR.
              </p>
            </li>
            <li>
              <p>
                Přehled hlavních účelů zpracování:
              </p>
              <ol type="i">
                <li>
                  <p>
                    Registrace, správa uživatelského účtu a poskytování Služby (včetně provozu Aplikace, nastavení funkcí, technické podpory, evidence předplatného a kreditů) – právním základem je plnění smlouvy a kroky přijaté před uzavřením smlouvy.
                  </p>
                </li>
                <li>
                  <p>
                    Propojení Aplikace s účtem Klienta na podporované platformě a technické zajištění funkčnosti Služby (včetně zpracování technických přístupových údajů) – právním základem je plnění smlouvy.
                  </p>
                </li>
                <li>
                  <p>
                    Fakturace, účetnictví, daňová agenda a plnění zákonných povinností – právním základem je plnění právní povinnosti Správce.
                  </p>
                </li>
                <li>
                  <p>
                    Bezpečnost, prevence zneužití, ochrana práv a vymáhání nároků (např. logování, detekce incidentů, řešení sporů, obrana právních nároků) – právním základem je oprávněný zájem Společnosti na bezpečném provozu Aplikace a ochraně jejích práv.
                  </p>
                </li>
                <li>
                  <p>
                    Vyřizování dotazů, stížností a hlášení problémů – právním základem je plnění smlouvy, plnění právní povinnosti (je-li relevantní) a/nebo oprávněný zájem Společnosti na řádné komunikaci se zákazníky.
                  </p>
                </li>
                <li>
                  <p>
                    Zasílání obchodních sdělení zákazníkům týkajících se vlastních obdobných služeb Společnosti – právním základem je oprávněný zájem Společnosti a postup dle příslušných pravidel pro elektronická obchodní sdělení; Klient má možnost se kdykoliv jednoduše odhlásit.
                  </p>
                </li>
                <li>
                  <p>
                    Marketing, newslettery pro nezákazníky, personalizace reklam a remarketing – právním základem je souhlas subjektu údajů, pokud je takový souhlas vyžadován.
                  </p>
                </li>
                <li>
                  <p>
                    Analytika a zlepšování webu/Aplikace – právním základem je souhlas (u ne-nezbytných cookies a obdobných technologií) a/nebo oprávněný zájem u nezbytných technických měření, pokud je takové použití přiměřené a zákonné.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Pokud je zpracování založeno na souhlasu, je souhlas dobrovolný a lze jej kdykoliv odvolat, aniž by tím byla dotčena zákonnost zpracování provedeného před odvoláním souhlasu.
              </p>
            </li>
            <li>
              <p>
                Pokud je zpracování založeno na oprávněném zájmu, Klient má právo proti takovému zpracování vznést námitku. V případě přímého marketingu lze námitku uplatnit kdykoliv a Společnost následně přestane údaje pro tento účel zpracovávat.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Obchodní sdělení a marketingová komunikace</p>
          <ol type="a">
            <li>
              <p>
                Společnost může zasílat Klientům obchodní sdělení týkající se vlastních služeb, zejména pokud Klient využívá nebo v minulosti využíval služby Společnosti a jsou splněny podmínky stanovené právními předpisy.
              </p>
            </li>
            <li>
              <p>
                Z odběru obchodních sdělení se může Klient kdykoliv odhlásit jednoduchým způsobem, zejména:
              </p>
              <ol type="i">
                <li>
                  <p>v nastavení Aplikace,</p>
                </li>
                <li>
                  <p>pod odkazem Upravit preference zasílaných e-mailů v patičce e-mailu,</p>
                </li>
                <li>
                  <p>zasláním žádosti na e-mail info@stosuj.cz.</p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Pro marketingové účely nad rámec výše uvedeného (např. remarketingové publikum, personalizace reklam, některé newslettery) může Společnost zpracovávat údaje na základě souhlasu, pokud jej právní předpisy vyžadují.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Cookies a obdobné technologie</p>
          <ol type="a">
            <li>
              <p>
                Společnost používá na webu a v Aplikaci cookies a obdobné technologie (např. lokální úložiště, pixely, identifikátory zařízení) za účelem zajištění funkčnosti, bezpečnosti, měření návštěvnosti a případně marketingu/personalizace.
              </p>
            </li>
            <li>
              <p>
                Používané technologie lze rozdělit zejména na:
              </p>
              <ol type="i">
                <li>
                  <p>
                    Nezbytné (technické/funkční) – slouží k základnímu fungování webu a Aplikace, zabezpečení, přihlášení, ukládání preferencí a správě relace.
                  </p>
                </li>
                <li>
                  <p>
                    Analytické – slouží ke statistikám návštěvnosti, měření výkonu a zlepšování funkcionalit.
                  </p>
                </li>
                <li>
                  <p>
                    Marketingové / personalizační – slouží ke zobrazování relevantních nabídek, měření reklamních kampaní a remarketingu.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Nezbytné cookies a obdobné technologie jsou používány v rozsahu nutném pro fungování webu a Aplikace. Analytické a marketingové cookies/technologie Společnost používá pouze na základě platného souhlasu Klienta, pokud je takový souhlas vyžadován právními předpisy.
              </p>
            </li>
            <li>
              <p>
                Klient může svůj souhlas s používáním ne-nezbytných cookies kdykoliv změnit nebo odvolat prostřednictvím nastavení cookies na webu (cookie lišta / cookie centrum), případně nastavením svého prohlížeče. Odvolání souhlasu nemá vliv na zákonnost zpracování před odvoláním.
              </p>
            </li>
            <li>
              <p>
                Podrobnější informace o konkrétních cookies, jejich poskytovatelích a dobách uložení mohou být uvedeny v samostatné cookie politice nebo v nastavení cookies na webu.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Příjemci osobních údajů a zpracovatelé</p>
          <ol type="a">
            <li>
              <p>
                Osobní údaje jsou zpřístupňovány pouze oprávněným osobám Společnosti a smluvním partnerům, kteří údaje potřebují pro naplnění výše uvedených účelů, a to vždy v nezbytném rozsahu.
              </p>
            </li>
            <li>
              <p>
                Společnost využívá nebo může využívat zejména následující kategorie zpracovatelů/příjemců:
              </p>
              <ol type="i">
                <li>
                  <p>poskytovatelé hostingu, cloudových a serverových služeb,</p>
                </li>
                <li>
                  <p>poskytovatelé e-mailových a komunikačních služeb (transakční e-maily, zákaznická podpora),</p>
                </li>
                <li>
                  <p>platební partneři a platební brány (např. Stripe, ThePay, OpenNode),</p>
                </li>
                <li>
                  <p>poskytovatelé analytických a marketingových nástrojů (v rozsahu odpovídajícím nastavení souhlasu),</p>
                </li>
                <li>
                  <p>externí účetní, daňoví a právní poradci,</p>
                </li>
                <li>
                  <p>poskytovatelé bezpečnostních, monitorovacích a IT podpůrných nástrojů.</p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Společnost může osobní údaje předat orgánům veřejné moci (např. soudům, správním orgánům, orgánům činným v trestním řízení), pokud jí takovou povinnost ukládá právní předpis nebo je předání nezbytné k ochraně práv Společnosti.
              </p>
            </li>
            <li>
              <p>
                Pokud Společnost využívá reklamní a sociální sítě pro marketingové účely, činí tak v rozsahu a za podmínek odpovídajících udělenému souhlasu Klienta (je-li souhlas vyžadován).
              </p>
            </li>
            <li>
              <p>
                Se zpracovateli Společnost uzavírá odpovídající smlouvy o zpracování osobních údajů a dbá na to, aby byli vázáni mlčenlivostí a používali údaje výhradně k dohodnutým účelům.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Předávání osobních údajů do třetích zemí</p>
          <ol type="a">
            <li>
              <p>
                V rámci využívání některých technických, cloudových, analytických, komunikačních nebo platebních služeb může docházet k předání osobních údajů mimo Evropskou unii / Evropský hospodářský prostor (EU/EHP), pokud to vyžaduje infrastruktura příslušného poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Pokud k takovému předání dochází, Společnost zajišťuje, aby bylo uskutečněno v souladu s GDPR, zejména na základě rozhodnutí o odpovídající ochraně, standardních smluvních doložek (SCC) nebo jiného zákonného mechanismu.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Doba uchování osobních údajů</p>
          <ol type="a">
            <li>
              <p>
                Společnost uchovává osobní údaje pouze po dobu nezbytnou pro naplnění účelů zpracování nebo po dobu vyžadovanou právními předpisy.
              </p>
            </li>
            <li>
              <p>
                Konkrétní doby uchování se mohou lišit podle povahy údajů a účelu zpracování, typicky však platí:
              </p>
              <ol type="i">
                <li>
                  <p>
                    údaje o uživatelském účtu a poskytování Služby – po dobu trvání smluvního vztahu a přiměřenou dobu po jeho ukončení (např. pro řešení reklamací, sporů, ochranu právních nároků a technické dořešení účtu),
                  </p>
                </li>
                <li>
                  <p>
                    účetní a daňové doklady a související údaje – po dobu vyžadovanou příslušnými právními předpisy,
                  </p>
                </li>
                <li>
                  <p>
                    bezpečnostní a provozní logy – po dobu nezbytnou pro zabezpečení, detekci incidentů a provozní diagnostiku,
                  </p>
                </li>
                <li>
                  <p>
                    údaje zpracovávané na základě souhlasu (např. marketing/cookies) – do odvolání souhlasu, uplynutí doby, na kterou byl souhlas udělen, nebo do okamžiku, kdy odpadne účel zpracování,
                  </p>
                </li>
                <li>
                  <p>
                    údaje o obchodních sděleních zákazníkům – do uplatnění námitky / odhlášení odběru nebo do okamžiku, kdy již Společnost nemá zákonný důvod je zasílat.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <p>Je poskytnutí údajů povinné? Automatizované rozhodování a profilování</p>
          <ol type="a">
            <li>
              <p>
                Poskytnutí některých osobních údajů je nezbytné pro uzavření a plnění smlouvy (např. e-mail, údaje potřebné pro vedení uživatelského účtu a poskytování Služby, případně fakturační údaje pro vystavení daňového dokladu). Bez těchto údajů nemusí být možné založit účet, poskytovat Službu nebo provést úhradu.
              </p>
            </li>
            <li>
              <p>
                Poskytnutí údajů pro marketingové účely a udělení souhlasů s ne-nezbytnými cookies je dobrovolné. Pokud Klient souhlas neudělí nebo jej odvolá, nemá to vliv na možnost používat základní funkce Aplikace, s výjimkou funkcí, které jsou na těchto technologiích přímo závislé.
              </p>
            </li>
            <li>
              <p>
                Společnost neprovádí rozhodování založené výhradně na automatizovaném zpracování osobních údajů, které by mělo pro Klienta právní účinky nebo se jej obdobně významně dotýkalo, ledaže by o tom Klienta výslovně a srozumitelně informovala v konkrétním případě.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Práva subjektu údajů</p>
          <ol type="a">
            <li>
              <p>
                Klient má v souvislosti se zpracováním osobních údajů práva vyplývající z GDPR a souvisejících právních předpisů.
              </p>
            </li>
            <li>
              <p>
                Jedná se zejména o následující práva:
              </p>
              <ol type="i">
                <li>
                  <p>
                    Právo na informace a přístup k osobním údajům – Klient může požadovat potvrzení, zda jsou jeho osobní údaje zpracovávány, a pokud ano, získat přístup k těmto údajům a souvisejícím informacím.
                  </p>
                </li>
                <li>
                  <p>
                    Právo na opravu – Klient může požadovat opravu nepřesných nebo doplnění neúplných osobních údajů.
                  </p>
                </li>
                <li>
                  <p>
                    Právo na výmaz („právo být zapomenut“) – Klient může požadovat výmaz osobních údajů, pokud jsou splněny podmínky stanovené GDPR.
                  </p>
                </li>
                <li>
                  <p>
                    Právo na omezení zpracování – Klient může požadovat omezení zpracování v případech stanovených GDPR.
                  </p>
                </li>
                <li>
                  <p>
                    Právo na přenositelnost údajů – u údajů zpracovávaných automatizovaně na základě souhlasu nebo smlouvy může Klient požadovat předání údajů ve strukturovaném, běžně používaném a strojově čitelném formátu, případně jejich předání jinému správci, je-li to technicky proveditelné.
                  </p>
                </li>
                <li>
                  <p>
                    Právo vznést námitku – zejména proti zpracování založenému na oprávněném zájmu. Námitku proti zpracování pro účely přímého marketingu může Klient uplatnit kdykoliv.
                  </p>
                </li>
                <li>
                  <p>
                    Právo odvolat souhlas – pokud je zpracování založeno na souhlasu, lze souhlas kdykoliv odvolat.
                  </p>
                </li>
                <li>
                  <p>
                    Právo podat stížnost u dozorového úřadu – zejména u Úřadu pro ochranu osobních údajů (ÚOOÚ).
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Společnost vyřizuje žádosti subjektů údajů bez zbytečného odkladu, nejpozději zpravidla do 1 měsíce od obdržení žádosti. Ve složitých případech může být tato lhůta prodloužena o další měsíce v rozsahu dovoleném GDPR; o případném prodloužení a jeho důvodech bude Klient informován.
              </p>
            </li>
            <li>
              <p>
                Pokud má Společnost důvodné pochybnosti o totožnosti žadatele, může požádat o přiměřené doplnění informací k ověření identity, aby nedošlo k neoprávněnému zpřístupnění údajů.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Zabezpečení osobních údajů</p>
          <ol type="a">
            <li>
              <p>
                Společnost přijímá přiměřená technická a organizační opatření k zabezpečení osobních údajů proti neoprávněnému přístupu, změně, ztrátě, zničení nebo zneužití.
              </p>
            </li>
            <li>
              <p>
                Mezi používaná opatření mohou patřit zejména řízení přístupových oprávnění, šifrování nebo jiné formy ochrany dat při přenosu a/nebo uložení (tam, kde je to vhodné), logování přístupů, pravidelné aktualizace systémů, zálohování a obnova dat, interní pravidla a školení oprávněných osob.
              </p>
            </li>
            <li>
              <p>
                Technické přístupové údaje potřebné pro fungování Služby Společnost uchovává v zabezpečené podobě a v režimu omezeného přístupu pouze pro účely zajištění funkcionality Aplikace.
              </p>
            </li>
            <li>
              <p>
                Přestože Společnost uplatňuje přiměřená bezpečnostní opatření, nelze zcela vyloučit veškerá rizika spojená s přenosem dat prostřednictvím internetu nebo s provozem informačních systémů.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Změny těchto Zásad</p>
          <ol type="a">
            <li>
              <p>
                Společnost je oprávněna tyto Zásady přiměřeně měnit nebo aktualizovat, zejména při změně právních předpisů, používaných technologií, rozsahu poskytovaných služeb nebo zpracovatelských procesů.
              </p>
            </li>
            <li>
              <p>
                Aktuální verze Zásad bude vždy zveřejněna na webu Společnosti a/nebo v Aplikaci. O podstatných změnách může Společnost Klienta informovat e-mailem nebo prostřednictvím Aplikace.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <p>Závěrečné informace</p>
          <ol type="a">
            <li>
              <p>
                Tyto Zásady jsou účinné od 29. 7. 2026.
              </p>
            </li>
            <li>
              <p>
                Jakékoliv dotazy, žádosti nebo podněty ve vztahu ke zpracování osobních údajů lze zasílat na e-mailovou
                adresu: info@stosuj.cz
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </>
  );
};

export default PersonalDataProcessing;
